// 제출 config 경고 finding 의 화면 문구. BE 는 `message` 를 영어 개발자 문자열로 준다
// (검사 엔진이 로그·MCP 와 공유하는 값이다). 그래서 코드별 한국어 문장을 이 파일이 소유한다.
//
// 맵에 없는 코드는 BE message 를 그대로 표시한다. BE 가 검사 축을 늘려도 화면이 비지 않는다.
// 값(어떤 키)이 필요한 finding 은 BE message 가 그 값을 담고 있다. 그래서 한국어 문장은
// "무엇이 잘못되었고 무엇을 하면 되는지"만 표시하고, 값은 config_key 와 원문이 표시한다.

const VALIDATION_MESSAGES: Record<string, string> = {
  // ---- config 본문 ----
  config_yaml_invalid: "config 본문을 읽지 못했습니다. YAML 문법과 최상위 구조를 확인해 주세요.",
  override_key_missing:
    "선택한 config 에 없는 키라 덮어쓸 수 없습니다. 키를 새로 추가하려면 앞에 +를 붙이고, 아니면 그 키를 선언한 config 를 골라 주세요.",
  path_not_absolute: "입력 경로는 절대경로여야 합니다. / 또는 ti:// 로 시작하게 적어 주세요.",
  rotation_representation_invalid: "dataset.rotation_representation 값이 허용 목록 밖입니다.",

  // ---- cross-key 의존성 ----
  jepa_requires_vjepa_encoder:
    "JEPA co-train 을 켜려면 vision encoder 가 VJEPA21VisionEncoder 여야 합니다.",
  video_prediction_requires_timesteps:
    "video prediction co-train 을 켜려면 policy.buffer.next_obs_image_timesteps 가 비어 있지 않아야 합니다.",
  compile_conflicts_grad_norm:
    "손실별 grad norm 로깅과 policy.compile 은 함께 켤 수 없습니다. 둘 중 하나를 꺼 주세요.",
  warmup_scheduler_requires_total_steps:
    "CosineAnnealingWithLinearWarmup 스케줄러는 train.lr_scheduler_params.total_steps 가 필요합니다.",
  num_workers_zero:
    "worker 수는 1 이상이어야 합니다. 이 Training은 persistent worker 를 항상 사용합니다.",
  segmentation_mask_source_unverified:
    "segmentation mask 재구성은 Dataset에 mask 파일이 필요합니다. registry 가 미리 확인할 수 없으니 Dataset을 직접 확인해 주세요.",
};

// 화면에 표시할 문구. 아는 코드는 한국어 문장, 모르는 코드는 서버가 준 원문이다.
export function trainingValidationMessage(finding: { code: string; message: string }): string {
  return VALIDATION_MESSAGES[finding.code] ?? finding.message;
}

// 이 코드의 한국어 문장이 있는지. 원문을 함께 표시할지 정할 때 쓴다(아는 코드는 원문이 중복이다).
export function hasTrainingValidationMessage(code: string): boolean {
  return code in VALIDATION_MESSAGES;
}
